import { render, staticRenderFns } from "./newworkFlowDefine.vue?vue&type=template&id=1543f6d6&scoped=true&"
import script from "./newworkFlowDefine.vue?vue&type=script&lang=js&"
export * from "./newworkFlowDefine.vue?vue&type=script&lang=js&"
import style0 from "./newworkFlowDefine.vue?vue&type=style&index=0&id=1543f6d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543f6d6",
  null
  
)

export default component.exports